import { catchError } from '../CatchError/CatchError'

/**
 * Extrai a mensagem de negócio de um erro cujo corpo veio como `Blob`.
 *
 * <p>Numa resposta `responseType: 'blob'` o CORPO DO ERRO também chega como Blob, então o
 * `catchError` genérico devolveria "Algo de errado aconteceu!" e engoliria justamente a orientação
 * que importa — por exemplo, a recusa de uma exportação acima do teto, que vem com a instrução de
 * como reduzir o recorte. Sem isto, a pessoa vê um erro genérico e não sabe o que fazer.
 *
 * <p>O `Array.isArray` é necessário porque o `W3erpExceptionHandler` devolve uma **lista** de erros.
 * O `catch` do `JSON.parse` cobre o 403, cujo corpo é o `/error` do Spring Security e não o formato
 * de erro da aplicação: ali o fallback do `catchError` já produz a mensagem certa.
 *
 * <p>⚠️ **Existem outras duas implementações no repo, e elas NÃO são intercambiáveis** — esta veio
 * de `services/PredictAnalyticsService/getPredictAnalytics.tsx`, que cai em `catchError`. A de
 * `services/CriaPedido/getCriaPedido.tsx` cai em `erroEnvio`, que ainda extrai `msgUsuario` de um
 * corpo **não-blob**. Trocar aquela por esta num "dedup" futuro faria o erro de regra de negócio do
 * `POST /app/predicao/{id}/pedido` voltar a ser "Algo de errado aconteceu!", em silêncio. Se algum
 * dia for unificar, o fallback precisa ser parâmetro.
 */
export const mensagemDeErroEmBlob = async (error: unknown): Promise<string> => {
  const generico = catchError(error).message
  const corpo = (error as { response?: { data?: unknown } })?.response?.data
  if (!(corpo instanceof Blob)) {
    return generico
  }
  try {
    const texto = await corpo.text()
    const json = JSON.parse(texto)
    const erro = Array.isArray(json) ? json[0] : json
    return erro?.msgUsuario || generico
  } catch {
    return generico
  }
}
